export const styles = {
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 12
  }
}



// WEBPACK FOOTER //
// ./src/pages/MyQrCode/styles.js